import React, { memo } from 'react';
import styles from './SpriteFrame.module.scss';
import { inject } from 'mobx-react';
import { EDITOR_SPRITE_FRAMES_STORE } from 'store';
import { OverlayInfoSign } from 'components/common';
import { observer } from 'mobx-react-lite';
import { SpriteFrameProps } from './types';
import { spriteFrameSize } from 'utilities';

const SpriteFrame = (props: SpriteFrameProps) => {
  const {
    frameNumber = 1,
    showNumber = false,
    className = '',
    [EDITOR_SPRITE_FRAMES_STORE]: { styleAttrs },
    size = spriteFrameSize.s,
    style = {},
    ...rest
  } = props;

  if (!frameNumber) return null;

  const { url, backgroundSize, X, Y, width, height } = styleAttrs(frameNumber, size);

  return (
    <div
      className={[styles.container, className].join(' ')}
      style={{
        backgroundImage: `url(${url})`,
        backgroundPositionX: X,
        backgroundPositionY: Y,
        backgroundSize,
        backgroundColor: 'black',
        width,
        height,
        ...style
      }}
      {...rest}
    >
      {showNumber && <OverlayInfoSign text={frameNumber} />}
    </div>
  );
};

const arePropsEqual = (prevProps, nextProps) => {
  if (prevProps.frameNumber !== nextProps.frameNumber) return false;
  if (prevProps.className !== nextProps.className) return false;
  if (JSON.stringify(prevProps.style) !== JSON.stringify(nextProps.style)) return false;

  return true;
};

export default memo(
  inject(EDITOR_SPRITE_FRAMES_STORE)(observer(SpriteFrame)),
  arePropsEqual
);
